import React from "react";
import { CsvIcon } from "../../../../../../global components/Icons/CsvIcon";
import s from "./ExportPopOver.module.scss";
import { ExcelIcon } from "../../../../../../global components/Icons/ExcelIcon";
import { fetchBaseLocation } from "../../../../../../libs/common";
import { UseAuthToken } from "../../../../../../libs/api/userSession";

type PopOverItem = {
  text: string;
  icon: React.ReactNode;
  actions: () => void;
};
type PropType = {
  type: string;
  date:
    | {
        endDate: string | undefined;
        startDate: string | undefined;
      }
    | undefined;
  sort: "asc" | "desc" | undefined;
  status: "failed" | "delivered" | undefined;
  userType: string[] | undefined;
  voiceChannel: "voice" | "voice_call" | undefined;
  messagingChannel: "sms" | "mms" | undefined;
  financialChannel: "mms" | "sms" | "email" | "voice" | undefined;
  complianceStatus: "spam" | "revoked" | "failed" | undefined;
  limit: number;
  page: number;
};
function ExportPopOverContent({
  date,
  sort,
  status,
  type,
  userType,
  voiceChannel,
  messagingChannel,
  financialChannel,
  complianceStatus,
  limit,
  page,
}: PropType) {
  const token = UseAuthToken();
  const items: PopOverItem[] = [
    // {
    //   icon: <PDFIcon className={s.icon} />,
    //   text: "Export PDF",
    //   actions: () => handleDownload("pdf"),
    // },
    {
      icon: <CsvIcon className={s.icon} />,
      text: "Export CSV",
      actions: () => handleDownload("csv"),
    },
    {
      icon: <ExcelIcon className={s.icon} />,
      text: "Export EXCEL",
      actions: () => handleDownload("xlsx"),
    },
  ];
  const handleDownload = async (fileType: "csv" | "xlsx" | "pdf") => {
    try {
      // pick the correct report endpoint
      const endpoint =
        type === "voice"
          ? "voice"
          : type === "messaging"
            ? "messages"
            : type === "financial"
              ? "finance"
              : type;
      let url = "";
      // build query params
      const userParams = new URLSearchParams({
        export: fileType,
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) userParams.append("startDate", date.startDate);
      if (date?.endDate) userParams.append("endDate", date.endDate);
      if (userType?.length) {
        userType.forEach((item, index) => {
          userParams.append(`userTypes[${index}]`, item);
        });
      }
      if (sort) userParams.append("order", sort);

      const messagingParams = new URLSearchParams({
        export: fileType,
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) messagingParams.append("startDate", date.startDate);
      if (date?.endDate) messagingParams.append("endDate", date.endDate);

      if (messagingChannel) messagingParams.append("channel", messagingChannel);
      if (status) messagingParams.append("status", status);
      if (sort) messagingParams.append("order", sort);

      const emailParams = new URLSearchParams({
        export: fileType,
        messageType: "email",
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) emailParams.append("startDate", date.startDate);
      if (date?.endDate) emailParams.append("endDate", date.endDate);

      if (status) emailParams.append("status", status);
      if (sort) emailParams.append("order", sort);

      const voiceParams = new URLSearchParams({
        export: fileType,
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) voiceParams.append("startDate", date.startDate);
      if (date?.endDate) voiceParams.append("endDate", date.endDate);
      // if (voiceChannel) {
      //   voiceParams.append("channel", voiceChannel);
      //   voiceParams.append("messageType", voiceChannel);
      // }
      if (sort) voiceParams.append("order", sort);

      const financialParams = new URLSearchParams({
        export: fileType,
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) financialParams.append("startDate", date.startDate);
      if (date?.endDate) financialParams.append("endDate", date.endDate);

      if (financialChannel) financialParams.append("channel", financialChannel);
      if (sort) financialParams.append("order", sort);

      const complianceParams = new URLSearchParams({
        export: fileType,
        page: String(page),
        limit: String(limit),
      });
      if (date?.startDate) complianceParams.append("startDate", date.startDate);
      if (date?.endDate) complianceParams.append("endDate", date.endDate);

      if (complianceStatus) complianceParams.append("status", complianceStatus);
      if (sort) complianceParams.append("order", sort);

      const userUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${userParams.toString()}`;
      const messagingUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${messagingParams.toString()}`;
      const emailUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${emailParams.toString()}`;
      const voiceUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${voiceParams.toString()}`;
      const financialUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${financialParams.toString()}`;
      const complianceUrl = `${fetchBaseLocation}api/admin/reports/${endpoint}?${complianceParams.toString()}`;

      url =
        type === "user"
          ? userUrl
          : type === "messaging"
            ? messagingUrl
            : type === "email"
              ? emailUrl
              : type === "voice"
                ? voiceUrl
                : type === "financial"
                  ? financialUrl
                  : complianceUrl;
      // fetch with Bearer token
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        throw new Error("Failed to download file");
      }

      // convert to Blob
      const blob = await res.blob();

      // figure out file extension
      const extension = fileType === "xlsx" ? "xlsx" : fileType;

      // create a temporary link
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `Cloudivi-${endpoint}-report.${extension}`;
      document.body.appendChild(a);
      a.click();

      // cleanup
      a.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <div className={s.wrapper}>
      {items.map((item, index) => (
        <div key={index} className={s.item} onClick={item.actions}>
          {item.icon} <p className={s.text}>{item.text}</p>
        </div>
      ))}
    </div>
  );
}

export default ExportPopOverContent;
